import loadable from '@loadable/component';

export const MegalandingRootLoadable = loadable(() => import('./MegalandingRoot'), {
  fallback: undefined,
  ssr: false,
});
